
namespace Nobox.Administration {

    export class SyncDbBulkAction extends Serenity.Extensions.BulkServiceAction {
        private errorMessage = [];
        protected getParallelRequests() {
            return 10;
        }
        protected getBatchSize() {
            return 1;
        }
        showErrorMessage() {
            if (this.get_errorCount() != 0) {
                var message = "";
                this.errorMessage.forEach(x => {
                    message += `${x.id} = ${x.message}\n`;
                });
                Q.confirm(message, () => {
                    this.execute(this.errorMessage.map(x => x.id));
                    this.errorMessage = [];
                    this.set_errorCount(0);
                    this.set_successCount(0);
                }, {
                    title: `Sync DB Found ${this.get_errorCount()} Error. Process Sync DB Again?`,
                    
                })
            }
        }
        showResults() {
            super.showResults();
            this.showErrorMessage();
        }
        protected executeForBatch(batch) {
            TenantService.OrderBulkAction(
                {
                    EntityId: batch[0]
                },
                response => {
                    if (response.IsError) {
                        this.set_errorCount(this.get_errorCount() + batch.length);
                        this.errorMessage.push({
                            id: batch[0],
                            message: response.Message
                        });
                    } else {
                        this.set_successCount(this.get_successCount() + batch.length)
                    }
                },
                {
                    blockUI: false,
                    onError: response => {
                        this.set_errorCount(this.get_errorCount() + batch.length)
                        this.errorMessage.push({
                            id: batch[0],
                            message: response.Message
                        });
                    },
                    error: (xhr, status, msg) => {
                        this.set_errorCount(this.get_errorCount() + batch.length)
                        this.errorMessage.push({
                            id: batch[0],
                            message: msg
                        });
                        this.serviceCallCleanup();
                    },
                    onCleanup: () => this.serviceCallCleanup()
                });
        }
    }
}